export const DEFAULT_LANGUAGE = 'en'
export const FAQ_LANGUAGES_AVAILABLE = ['es', 'en', 'it']